module.exports = __webpack_public_path__ + "img/frame-bg.422585a6.png";